import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { IResortFeeDetail } from 'libraries/service/resources/model/search/IBooking';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { ICurrency } from 'libraries/service/resources/model/search/ICurrency';
import { ICurrencies } from 'libraries/service/resources/hotel/ISearchResponse';
import { ICost } from 'libraries/service/resources/hotel/IResourceHotel';
import { QuotationService } from 'libraries/hotel/services/quotation/quotation.service';
import { faCircle, IconDefinition,faMoneyBill } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'resort-fee',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <em *ngIf="fee">
        <span class="icon-sm">
            <fa-layers size="sm">
                <fa-icon [icon]="iconCircle" stackItemSize="2x" class="icon-money"></fa-icon>
                <fa-icon [icon]="iconMoney" [inverse]="true" stackItemSize="1x"></fa-icon>
            </fa-layers>    
        </span>
        
        {{ labels.resortFees}}

        <strong [innerHtml]="this.price | priceRealAmount: this.currencyCode"></strong>

        <ng-container *ngIf="fee.included; else notIncluded">
            {{ labels.included }}
        </ng-container>

        <ng-template #notIncluded>
            <strong>{{ labels.notIncluded }}</strong>
        </ng-template>
    </em>
    `,
    styles: [`

    .icon-sm {
        font-size:0.62em;
        margin-right: 2px;
        margin-left: -2px;
        margin-top: -2px;
    }

    .icon-money {
        margin-top: -1px;
    }

    .included{
        color: #aaa;
    }

    `],
})
export class ResortFeeComponent implements OnChanges {
    @Input()
    public fee: IResortFeeDetail;

    @Input()
    public currency: ICurrency;

    @Input()
    public currencies: ICurrencies;

    public labels: ILabels = {
        resortFees: Yii.t("wui-shared-js", "Taxe de séjour"),
        included: Yii.t("wui-shared-js", "(incluse dans le prix)"),
        notIncluded: Yii.t("wui-shared-js", "(à payer sur place)"),
    };

    public price: number;
    public currencyCode: string;

    public iconCircle: IconDefinition = faCircle;

    public iconMoney: IconDefinition = faMoneyBill;

    public constructor(
        private quotationService: QuotationService
    ){}

    public ngOnChanges(changes: SimpleChanges): void{
        this.initPrice();
    }

    private initPrice(){
        if (this.fee){
            const prices: ICost = this.fee.total.cost;
            this.currencyCode = Object.keys(prices).find((x) => true);

            if (this.currency && prices[this.currency.code]){
                this.currencyCode = this.currency.code;
            }

            let decimals = 2;

            if (this.currencies && this.currencies[this.currencyCode]){
               decimals = this.currencies[this.currencyCode].decimals;
            }else if (this.currency && this.currencyCode === this.currency.code){
               decimals = this.currency.decimals;
            }

            this.price = this.quotationService.getPrice(this.fee.total.cost, { code: this.currencyCode, decimals });
        }
    }
}
